import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "./views/Dashboard.vue";
import Schedule from "./views/Schedule.vue";
import History from "./views/History.vue";
import Settings from "./views/Settings.vue";
import Login from "./views/Login.vue";
import { api } from "./api.js";

var routes = [
	{ path: "/", name: "dashboard", component: Dashboard },
	{ path: "/schedule", name: "schedule", component: Schedule },
	{ path: "/history", name: "history", component: History },
	{ path: "/settings", name: "settings", component: Settings },
	{ path: "/login", name: "login", component: Login },
];

var router = createRouter({
	history: createWebHistory(),
	routes,
});

// No stored token → login page, unless this session already discovered the
// backend runs with auth disabled (dev / placeholder API_TOKEN); Login.vue
// sets the flag after probing. A stored-but-stale token is caught at request
// time instead: api.js redirects here on the first 401.
router.beforeEach((to) => {
	if (to.name === "login") { return true; }
	if (api.getToken()) { return true; }
	if (sessionStorage.getItem("bed.authOpen") === "1") { return true; }
	return { name: "login" };
});

export default router;
